/**
* @title checkout_helper.js: Feature level module
* @description Utility module associated with checkout
*/
define([], function(){
	let Checkout = {
		/**
		* Default implementation of the done promise used by ajax_update_state.
		* The data structure this function uses is defined in JSONLayout.jsp.
		* Update the state of each html segment. This assumes that the
		* property key maps to the id of the html segment to replace. Also,
		* if there any errors defined on the response_obj.error,
		* display them.
		* @param  {String} data       The JSON returned as a string. Contains
		*                             the encoded html that must be decoded
		*                             and then is injected into the DOM.
		* @param  {String} textStatus [description]
		* @param  {String} jqXHR      [description]
		* @param  {Object} options    The options object originally passed to
		*                             ajax_update_state
		* @return {void}
		*
		* @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_done
		*/
		ajax_update_default_done: function(data, textStatus, jqXHR, options){
			try {
				let response_obj = typeof(data) === 'object' ? data : JSON.parse(data);
				let defaultOptions = {
					ajax_replace_content: COSTCO.Checkout.ajax_replace_content,
					ajax_handle_errors: COSTCO.Checkout.ajax_handle_errors,
					ajax_update_post_done: function(){},
					error_container: '',
					scrollToError: true,
				};
				$('body').trigger('costco.ajax.content.update.start', response_obj);
				let mergedOptions = $.extend(true, {}, defaultOptions, options);
				// Inject New Html
				mergedOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
				// Post Html Injection
				mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
				// Handle any Errors and perform cleanup
				mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
				$('body').trigger('costco.ajax.content.update.end', response_obj);
			} catch(e){
				console.error(e);
			}
			console.log('ajax_update_default_done');
		},

		/**
		* @DEPRECATED - Replaced with: AjaxModular.ajax_replace_content
		*/
		ajax_replace_content: function(response_obj, mergedOptions, defaultOptions){
			Object.keys(response_obj.payload.html).forEach(function(key){
				let encoded_html = response_obj.payload.html[key];
				if(mergedOptions.replaceKey){
					if(mergedOptions.replaceKey.original == key){
						key = mergedOptions.replaceKey.replace;
					}
				}
				$('#' + key).html(COSTCO.util.get_decoded_html(encoded_html));
				console.log('ajax_replace_content' + key);
			});
		},

		/**
		* @DEPRECATED - Replaced with: AjaxModular.ajax_handle_errors
		*/
		ajax_handle_errors: function(response_obj, mergedOptions, defaultOptions){
			if($('#isBDAppVar').val() == 'BD'){
				if (COSTCO.CreditCard.isCybersourceEnabled()) {
					$('.error:not(.error-qty-increment, #cc_cvc, #cc_cvc_err_msg)').empty();
				} else {
					$('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
				}
			} else {
				if (COSTCO.CreditCard.isCybersourceEnabled()) {
					$('.error:not(select, #cc_cvc, #cc_cvc_err_msg)').empty();
					$('.error:not(select)').removeClass('critical-notification');
				} else {
					$('.error:not(select)').empty().removeClass('critical-notification'); // clear any errors that may be on the page
				}
				
				if(!$('.order-error').find('p').text().length){
					$('.order-error').removeClass('critical-notification');
				}
			}
			let error_container = mergedOptions.error_container;
			if(Checkout.isReviewPage() || Checkout.isPaymentPage()){
				if(typeof TokenGateway !== 'undefined'){
					TokenGateway.refreshGateway();
				}
				if(response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr){
					error_container = '#errquantity_application_';
					$('#errquantity_application_').addClass('critical-notification');
					$('#errquantity_application_').removeClass('error');
					$("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');

					if($('#errquantity_application_').html().trim() == ''){
						$('#errquantity_application_').html(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
					}
				} else {
					if(typeof COSTCO.CreditCard !== 'undefined'){
						COSTCO.CreditCard.init();
					}
					if(typeof COSTCO.wallet !== 'undefined'){
						//wallet module is not used in USBD - all other allow
						if(wcs.storeId !='11301'){
							COSTCO.wallet.init();
						}
					}
					if(typeof COSTCO.CC !== 'undefined'){
						COSTCO.CC.init();
					}
				}
			}
			let input_container = mergedOptions.input_container;
			let application = response_obj.error.application || [];
			let exception = response_obj.error.exception || [];
			let error_html = '';
			if(exception.length > 0){
				if(wcs.langId !== -25){
					error_html += '<p>Sorry, we are experiencing technical issues. Please try again later.</p>';
				} else {
					error_html += '<p>Désolé, nous éprouvons des difficultés techniques. Veuillez réessayer plus tard.</p>';
				}
			}
			application.forEach(function(error_message){
				error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
			});
			// if there is a redirect, store the error in sessionStorage and redirect user,
			// otherwise error will show in error container
			if(response_obj.error.redirect){
				if(typeof sessionStorage != 'undefined'){
					sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
				}
				document.location.href = '/' + response_obj.error.redirect;
				return;
			}
			if(typeof(error_container) === 'string'){
				error_container = $(error_container);
			}
			if(input_container){
				if((application.length + exception.length) > 0){
					$(input_container).addClass('error');
					$(input_container).attr('aria-invalid', 'true');
				} else {
					$(input_container).removeClass('error');
					$(input_container).attr('aria-invalid', 'false');
				}
			}
			if(error_container == '' || error_container.length == 0){
				$('body').trigger('costco.ajax.content.update.sucess', response_obj);
				return;
			}
			error_container.children().remove();
			if(response_obj.metadata.quantityUpdatedForCashCardPaymentErr && error_html.length > 0){
				$(error_container).html('');
				COSTCO.Checkout.showPaymentEditOption($('input[name=payMethodId]').val());
			}
			if(error_html.trim() != ''){
				error_container.append("<p class=\"sr-only\">" + messages.ERROR + "</p>");
				error_container.append(error_html);
				error_container.addClass('critical-notification');
				if(mergedOptions.not_critical_notification !== undefined && mergedOptions.not_critical_notification){
					error_container.removeClass('critical-notification');
				}
				
				// add quantity limit error at the item level for BD
				if($('#isBDAppVar').val() == 'BD'){	
					$('.order-item').each(function() {
						if($(this).find('.itemPartNumberPurchased').html() == response_obj.error.itemNumber){
							$(this).find('.critical-notification').append(error_html).removeClass('hide');
						}
					});
				}
				
				COSTCO.util.announceSRMessage(messages.ERROR + "&nbsp" + error_html);
			}
			// Add/remove class critical-notification for page-top error in Cart page
			if(error_container.attr('id') == 'errquantity_' && checkoutPage && checkoutPage == 'cart'){
				if(error_container.html().trim() != ''){
					error_container.addClass('critical-notification');
				} else {
					error_container.removeClass('critical-notification');
				}
			}
			if($('#errquantity_application_').length > 0 && $('#errquantity_application_').html().trim() != ''){
				if(!COSTCO.OrderSummary.isAllPaidByCashCard()){
					COSTCO.Checkout.showPaymentEditSection($('input[name=payMethodId]').val());
				} else {
					$('#errquantity_application_').html('');
					$('#errquantity_application_').removeClass('critical-notification');
					$('#errquantity_application_').addClass('error');
				}
				COSTCO.CC.init();
			} else if($('#errquantity_application_').length > 0){
				$('#errquantity_application_').removeClass('critical-notification');
				$('#errquantity_application_').addClass('error');
				//This will do the real work - I have no idea what the above code does.
				//This will place error messages in-line
			} else if($('#isBDAppVar').val() == 'BD'){
				COSTCO.OrderItems.placeGlobalCartErrorsInLine(response_obj);
				if($("#contractErrContainer").length > 0){
					error_container.addClass('hide');
					if(!$("#contractErrContainer").is(':visible'))
						$("#contractErrContainer").removeClass('hide');
				} else {
					error_container.removeClass('hide');
				}
			}
			if(mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)){
				$('body').trigger('costco.ajax.content.update.error', response_obj);
				$('body, html').animate({
					scrollTop: $(error_container).offset().top - 30,
				}, 800);
			}
		},

		/**
		* A generic function to make ajax requests. The only difference being
		* that this function sets a default done promise that injects html
		* into the DOM with the response data. Pass done, fail, and always
		* functions to the options object to be called in each respective promise.
		* @param  {Object} options Object containing options to pass to $.ajax
		*                          and functions to call within $.ajax promises.
		* @return {void}
		*
		* @DEPRECATED - Replaced with: AjaxModular.ajax_update_state
		*/
		ajax_update_state: function(options, page){
			// Prevent code breaking if checkoutPage is undefined.
			//let checkoutPage = typeof window.checkoutPage == 'undefined' ? false : window.checkoutPage;
			$('.order-ajax').addClass('ajax-busy');
			let checkoutPageName = (typeof checkoutPage === 'undefined') ? false : checkoutPage;
			if(options.page || checkoutPageName){
				options.url = COSTCO.util.makeUrl(options.url, {
					'checkoutPage': options.page || checkoutPageName
				});
			}
			if(!options.done){
				options.done = COSTCO.Checkout.ajax_update_default_done;
			}
			if(!options.always){
				options.always = COSTCO.Checkout.ajax_update_default_always(options.inputContainer);
			}
			COSTCO.util.ajax(options);
		},

		/**
		* Extracting default function out so we can perfom this and something else
		*
		* @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_always
		*/
		ajax_update_default_always: function(inputContainer){
			$('.order-ajax').removeClass('ajax-busy');
			COSTCO.Checkout.validator = undefined;
			// ALM 54928 Possible patch fix for issue that exists in prod, NOT PERMANENT!
			if($('#isBDAppVar').val() == 'BD'){
				if(!$('.order-error').find('p').text().length){
					$('.order-error').removeClass('critical-notification');
				}
			}
			// Create a function to focus back to the original input after
			// the ajax call is done
			// This will only be done only if there input is defined in the option payload
			// ALM 54928: Possible patch fix for issue that exists in prod, NOT PERMANENT!
			if($('#isBDAppVar').val() == 'BD'){
				if(!$('.order-error').find('p').text().length){
					$('.order-error').removeClass('critical-notification');
				}
			}
			if(inputContainer){
				let focusInput = $(inputContainer);
				if(focusInput.length > 0){
					// If we have the id then lets use it
					if(focusInput[0].id){
						console.log(focusInput[0].id);
						$('#' + focusInput[0].id).focus();
					} else {
						console.log('Working for it');
						// Ok no id so now we have to do work
						if(focusInput[0].nodeName == 'INPUT'){
							if(focusInput.attr('type') == 'radio' && focusInput.attr('name')){
								$('input:checked[name="' + focusInput.attr('name') + '"]').focus();
							}
						}
					}
				}
			}
		},

		/**
		* Displays the error message stored in sessionStorage from the previous page
		* where error was sent to client, but a redirect needed to happen
		*/
		display_error_after_redirect: function(){
			if(typeof sessionStorage != 'undefined' && sessionStorage.getItem('errorMessage')){
				let $container = $('#progress-meter-row').children().last();
				$container.addClass('error');
				$container.append(sessionStorage.getItem('errorMessage'));
				sessionStorage.removeItem('errorMessage');
			}
		},

		/**
		* Util to give an interactive character count down
		* @param  {ojbect} label    pass the jquery obj where you want the
		*                           countdown to reflect
		* @param  {object} textarea pass a 'text' input
		*                           (input[type='text'],textarea) to count
		* @return {void}
		*/
		character_count: function(label, textarea){
			if($(label).length > 0 && $(textarea).length > 0){
				let max = parseInt($(textarea).attr('maxlength'));
				$(label).text(max - $(textarea).val().length);
				$(textarea).unbind('keyup').on('keyup', function(){
					updateLabelCount(this, label);
				});
				$(textarea).unbind('change').on('change', function(){
					updateLabelCount(this, label);
				});
				function updateLabelCount(textarea, label){
					let count = $(textarea).val().length;
					$(label).text(max - count);
				}
			}
		},

		getAuthToken: function(){
			return $('[name=authToken]').first().val();
		},

		show_busy_indicator: function(){
			$('.order-ajax').addClass('ajax-busy');
		},

		remove_busy_indicator: function(){
			$('.order-ajax').removeClass('ajax-busy');
		},

		/**
		* If PAD is the only choice in div.delivery-option-radios, PAD is required.
		* Else it ain't.
		* @param  {object}  delivery_radios The jQuery object that maps to
		*                                   div.delivery-option-radios
		* @return {Boolean} Is PAD required as a shipping method for this item.
		*/
		is_pad_required: function(delivery_radios){
			let $radio_containers = $(delivery_radios).children();
			return $radio_containers.length === 1 && $radio_containers.first().hasClass('pad');
		},

		/**
		* Is a PAD delivery option radio selected?
		* @param  {object}  delivery_radios The jQuery object that maps to
		*                                   div.delivery-option-radios
		* @return {Boolean}                 Is the PAD radio selected?
		*/
		is_pad_selected: function(delivery_radios){
			let isSelected = false;
			let $pad_input = $(delivery_radios).find('.pad input[type=radio]');
			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE){
				let $padWithoutNextDay = $(delivery_radios).find('.individualShipBlock, .individualPharmacyShipModes');
				if($(delivery_radios).find(".grocery-header-text").length === 0 && $(delivery_radios).find(".frozen-header-text").length === 0){
					if($padWithoutNextDay.length === 0){
						$(delivery_radios).find(".selection-box-v2.pad").attr("checked");
						isSelected = true;
					} else {
						isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
					}
				}
			} else {
				isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
			}
			return isSelected;
		},

		/**
		* Clean inputs with quantity value unit
		*/
		clear_form: function(){
			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
				let inputs = $('input[name^=quantity]');
				if(inputs){
					inputs.each(function(){
						let parent = $(this).parent('div');
						parent.removeClass('error');
					}
					);
				}
			}
		},
		/**
		* Generic validator instance
		* @type $.validator
		*/
		validator: undefined,

		/**
		* This function is used for dynamic form validation. Its meant to be
		* wrapped in a decorator and configured appropriately. (See how
		* orderitems.js uses it). Everything keys off of options_obj.rule. If
		* a rule is supplied, we're matching that rule with a single dynamic input.
		* Otherwise, we want to validate multiple, dynamic inputs. We pass a
		* options_obj.validate_inputs function(See orderitem.js example) that
		* applies the rules we want. Finally, if we're valid, execute the supplied
		* callback
		* @param  {object} options_obj The object with the following properties:
		*                              {
			*                                form: <The form we're validating>,
			*                                input: <optional: input to validate>,
			*                                validate_inputs: <The fn to add N number
			*                                  of rules>,
			*                                rule: <optional: the object that represents
			*                                  the rule to validate with provided input>,
			*                                rules_config_obj: <All of the rules to
			*                                  potentially pass to $.fn.validator>,
			*                                callback: <The function to pass on
			*                                  successful validation>
			*                              }
		* @return {void}
		*/
		_dynamic_validate: function(options_obj){
			let self = COSTCO.Checkout;
			let $form = options_obj.form;
			var $input = options_obj.input;
			let validate_inputs = options_obj.validate_inputs;
			let rule = options_obj.rule;
			let rules_config_obj = options_obj.rules_config_obj;
			let callback = options_obj.callback;
			//callbackParams is used in case callback function has parameters
			let callbackParams = options_obj.callbackParams;
			let options = {
				focusInvalid: false,
				errorElement: 'span'
			};
			let errorPlacement = options_obj.errorPlacement;
			if(self.validator && rule != 'quantity'){
                    $form.destroyValidator(self.validator);
                    COSTCO.Checkout.clear_form();              
			}
			// If we're not validating a single input, we want to call the invalid
			// handler so when we throw an error we scroll to where that error is.
			if(!rule){
				options.invalidHandler = COSTCO.util.invalid_handler;
			}
			self.validator = $form.validate(options);
			if(rule){ // We want a specific rule bound on the input.
				// If we're being called as an inline event handler on an input, we good, otherwise
				// use the data-id attribute of the calling DOM element to get the input.
				var $input = $input.prop('tagName') === 'INPUT' || $input.prop('tagName') === 'SELECT' ?
				$input : $('#' + $input.data('id'));
				$input.rules('add', rules_config_obj[rule]);
				if(!(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE)){
					if($('#isBDAppVar').val() == 'BD' && rule == 'quantity'){
						self.validator.settings.errorClass = self.validator.settings.errorClass + ' error-qty-increment';
					}
				}
			} else { // Case where we have mulitple dynamic inputs to validate
				if(validate_inputs) validate_inputs(rules_config_obj);
			}
			if(errorPlacement){
				self.validator.settings.errorPlacement = errorPlacement;
			}
			// $.validator.form triggers form validation programmatically
			// If we're a valid form, execute the callback.
			if(self.validator.form()){
				if(callback){
					if(callbackParams !== undefined && callbackParams.length > 0){
						callback(callbackParams);
					} else {
						callback();
					}
				}
			}
		},

		editMyAccount: function(view){
			var path = "/AccountInformationView?langId="+wcs.langId+"&storeId="+wcs.storeId+"&catalogId="+wcs.catalogId+"&crmSpecificView="+view
			window.location.href = path;
		},

		/**
		* This is the inline event handler for membership application item.
		* It needs to redirect back to the application page.
		* @param  {[type]} partNumber  [description]
		* @param  {[type]} orderItemId [description]
		* @param  {[type]} orderId     [description]
		* @return {void}
		*/
		editApplication: function(partNumber, orderItemId, orderId){
			let path = '';
			try {
				$.cookie('APPLICATION_TRACKING_COOKIE', null, {
					path: '/',
				});
			} catch(e){}
			if($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1){
				path = `/MembershipApplicationView?productPartNumber=${partNumber}&fromPage=${currentPage}`;
			} else {
				path = `/QuickMembershipApplicationView?productPartNumber=${partNumber}&fromPage=${currentPage}`;
			}
			$.cookie('APPLICATION_TRACKING_COOKIE', orderItemId);
			let currentPage = window.location.pathname.substr(1);
			if(currentPage.includes('CheckoutReviewView')){
				path += `&orderId=${orderId}`;
			}
			window.location.href = path;
		},

		/**
		* Opens 'Remove Memebrship/Renewal Warning Modal' dialog modal.
		* @return {void}
		*/
		openRemoveWarningModal: function(isRenew, orderItemId){
			COSTCO.dialog.createExtDialogBox({
				title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
				body: isRenew ? (memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text) : (memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text),
				primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
				secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
				dialogclasses: 'leave-page-modal',
				primary_event: function(){
					COSTCO.dialog.close();
				},
				secondary_event: function(){
					COSTCO.OrderItems.remove_item(orderItemId);
				},
			});
		},

		openRemoveWarningModal_v2: function(isRenew, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart){
			COSTCO.dialog.createExtDialogBox({
				title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
				body: isRenew ? (memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text) : (memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text),
				primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
				secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
				dialogclasses: 'leave-page-modal',
				primary_event: function(){
					COSTCO.dialog.close();
				},
				secondary_event: function(){
					COSTCO.OrderItems.remove_item_v2(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
				},
			});
		},

		deletePaymentInstructionsForOrder: function(){
			return new Promise(function(resolve, reject){
				if(Checkout.isCheckoutPage()){ // if we're on the checkout page
					var currentOrderId = $('INPUT[name="orderId"]').val();
					COSTCO.util.ajax({
						url: '/AjaxDeletePaymentInstructionsForOrder',
						method: 'POST', 
						dataType: 'json', 
						data: {
							orderId: currentOrderId
						},
						success: function(result){							
							// if no xcreditcard id, clear everything in the form. Else, clear the piId and populate the xCreditCardId in the form
							if (result.xcreditCardId.length === 0){
								if($('#piIdCashCard').length>0){
									$('#piIdCashCard').val('');
								}													
								if($('#account').length>0){
									$('#account').val('');
								}							
								if($('#cc_expiry_date').length>0){
									$('#cc_expiry_date').val('');
								}	
								if($('#cc_nameoncard').length>0){
									$('#cc_nameoncard').val('');
								}
							} else {
								if($('#piIdCashCard').length>0){
									$('#piIdCashCard').val('');
								}
								if($('[name="xCreditCardId"]').length>0){
									$('[name="xCreditCardId"]').val(result.xcreditCardId);
								}		
							}

							console.log('Deleted payment instructions for order ' + currentOrderId);
							resolve();
						},
						fail: function(error){
							console.error('Error deleting payment instructions for order ' + currentOrderId);
							resolve();
						}
					});
				} else { // if we're not on the checkout page, do nothing
					resolve();
				}
			});
		},

		showPaymentEditOption: function(payType, skipCreateToken){
			if (payType == 'ACH' && hasCashCard){
				COSTCO.CC.removeCashCard($('#remove-cash-card-link'));
			}
			if(/^(Check|LineOfCredit)$/i.test(payType)){
				Checkout.showPaymentEditSection(payType);
			} else {
				Checkout.deletePaymentInstructionsForOrder().then(function(){
					COSTCO.Checkout.moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay();
					if(undefined == skipCreateToken) {
						createTokenSessionId().then(function(){
							Checkout.showPaymentEditSection(payType);
						});
					}
				});
			}
		},

		showPaymentEditSection: function(payType){
			$('#payment-method-radio-buttons').removeClass('hide');
			$('#cod-ach-acr-payment').removeClass('hide');
			$('#cc-payment-block-title').removeClass('hide');
			$('#cc-payment-block').removeClass('hide');
			$('#credit-card-address-block').removeClass('hide');
			$('#cc-payment-address-block').removeClass('hide');
			$('#credit-card-block').removeClass('hide');
			$('#wallet-block').removeClass('hide');
			$('#credit-card-info-container').addClass('hide');
			$('#creditcard-block-form').removeClass('display');
			$('#single-page-checkout #cc-payment-block').attr('do-not-show', 'false');
			$('.payment-method-change').addClass('hide');
			$('#applepay-payment-block').addClass('hide');
			$('#applepay-block-form').removeClass('display');
			$('#applepay-info-container').addClass('hide');
			$('#place-order-button-regular').removeAttr('do-not-show');
			$('#place-order-button-applepay').attr('do-not-show','true');
	        $('#place-order-button-regular').removeClass('hide');
	        $('#place-order-button-applepay').addClass('hide');
	        if(COSTCO.Checkout.displayAllPayments()){
	        	$('#credit-card-block-review').addClass('hide');
	        	$('input[id=usedPayMethod]').val('');
	        }
	        
	        
			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
				$('#wallet-payment-address-form').addClass('hide');
				$('#payment-address-form').removeClass('hide');
				$('#payment-address-form .address-change-link-B').removeClass('hide');
				$('input[id=appliedPayMethod]').val('');
			}
			if($('#isBDAppVar').val() == 'BD'){
				
				if(COSTCO.util.isNdEnabled()){
					$('#ach-block').removeClass('hide');
				}
				else if(!COSTCO.util.isExternalCarrierShipmode()){
					$('#check-del-block').removeClass('hide');
					$('#ach-block').removeClass('hide');
					$('#acc-receiv-block').removeClass('hide');
				}
				
				var paymentType = ($('#ordPayInsVal').length > 0) ? $('#ordPayInsVal').val() : payType;
				if(paymentType == 'Check'){
					COSTCO.wallet.showCheckOnDeliverySection();
				} else if(paymentType == 'ACH'){
					COSTCO.wallet.showACHSection();
				} else if(paymentType == 'LineOfCredit'){
					COSTCO.wallet.showAcctReceivableSection();
				} else if($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')){
					$('#wallet-info-div').addClass('hide');
					$('#wallet-change-link').addClass('hide');
					if(wcs.locale == 'en_CA' || wcs.locale == 'fr_CA'){
						COSTCO.wallet.showMasterpassSection();
					} else {
						COSTCO.wallet.disableUseExistingWallet();
						COSTCO.wallet.showVisaSection();
					}
				} else {
					COSTCO.wallet.showCCSection();
					Checkout.reValidateCVV();
				}
			} else if($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')){
				$('#wallet-info-div').addClass('hide');
				$('#wallet-change-link').addClass('hide');
				if(wcs.locale == 'en_CA' || wcs.locale == 'fr_CA'){
					COSTCO.wallet.showMasterpassSection();
				} else {
					COSTCO.wallet.disableUseExistingWallet();
					COSTCO.wallet.showVisaSection();
				}
				COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('wallet');
			} else {
				COSTCO.wallet.showCCSection();
				Checkout.reValidateCVV();
				COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('credit card');
			}
			$('#auto-renew-div').appendTo($('#save_CC').parent().parent());
			$('#auto-renew-div').removeClass('mt-16');
			$('#auto-renew-div').addClass('mt-5');
			$('#auto-renew-div').addClass('mb-16');
			$('#autorenew-invalid-saved-card-div').addClass('hide');
			return false;
		},

		hidePaymentEditSection: function(){
			$('#payment-method-radio-buttons').addClass('hide');
			$('#cod-ach-acr-payment').addClass('hide');
			$('#cc-payment-block').addClass('hide');
			$('#credit-card-block').addClass('hide');
			$('#credit-card-address-block').addClass('hide');
			$('#cc-payment-address-block').addClass('hide');
			$('#wallet-block').addClass('hide');
			if($('#isBDAppVar').val() == 'BD'){
				$('#check-del-block').addClass('hide');
				$('#ach-block').addClass('hide');
				$('#acc-receiv-block').addClass('hide');
			}
		},

		clickToPayWasTriggered: function(){
			var value = sessionStorage.getItem('CLICK_TO_PAY_TRIGGERED');
			return (value ? true : false);
		},

		removeClickToPayTriggered: function(){
			sessionStorage.removeItem('CLICK_TO_PAY_TRIGGERED');
		},

		setClickToPayTriggered: function(){
			sessionStorage.setItem('CLICK_TO_PAY_TRIGGERED', true);
		},

		moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay: function(){
			if(COSTCO.Checkout.clickToPayWasTriggered()){
				var btn = $('#orderSummaryCheckoutButton');
				if(btn.length){
					var currentStepNumber = parseInt(btn.attr('current-step-number')), finalStepNumber = CHECKOUTSTEPS.length;
					// if we're on the last checkout step
					if(currentStepNumber > 1 && currentStepNumber == finalStepNumber){
						var previousStepIndex = (currentStepNumber - 2), previousStepNumber = (currentStepNumber - 1)
						btn.val(CHECKOUTSTEPS[previousStepIndex].text).attr('onclick', 'COSTCO.OrderSummary.checkoutSteps.submitCheckoutStep(' + previousStepNumber + ')');
					}
				}
			}
			COSTCO.Checkout.removeClickToPayTriggered();
		},

		updateCheckoutForm : function(){
			var val = this.checked ? 'on' : 'off';
			$('#isSavedPaymentAutoRenew').prop('value', val);
		},

		isCheckoutPage: function(){
			return ($('#CheckoutPaymentForm').length ? true : false);
		},

		isCartPage: function(){
			return ($('#cart').length > 0);
		},

		isReviewPage: function(){
			var isReviewPage = false;
			let currentPage = window.location.pathname.substr(1);
			if(currentPage.includes('CheckoutReviewView')){
				isReviewPage = true;
			}
			return isReviewPage;
		},

		isPaymentPage: function(){
			var isPaymentPage = false;
			let currentPage = window.location.pathname.substr(1);
			if(currentPage.includes('CheckoutPaymentView')){
				isPaymentPage = true;
			}
			return isPaymentPage;
		},

		reValidateCVV: function(){
			if($('#cc_expiry_date').val() != ''){
				COSTCO.CreditCard.validate.creditCardForm();
				$("label[for='cc_cvc_validator']").text(messages.CVV_REENTER);
			} else {
				$('#save_CC').prop('checked', false);
			}
		},
		toggleCartAccordion: function(orderItemId){
			if($('#cart-accordion-header-1-'+orderItemId).hasClass('collapsed')){
				$('#cart-accordion-header-1-'+orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
				$('#cart-accordion-right-div-'+orderItemId).hide();
				$('#arrow-'+orderItemId).remove();
				$('#cart-accordion-header-1-'+orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-"+orderItemId+"'></i>");
			} else {
				$('#cart-accordion-header-1-'+orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
				$('#cart-accordion-right-div-'+orderItemId).show();
				$('#arrow-'+orderItemId).remove();
				$('#cart-accordion-header-1-'+orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-"+orderItemId+"'></i>");
			}
		},
		
	    
	    membershipAutoRenewOptionOptedIn: function(){
	    	window.digitalDataEvents = window.digitalDataEvents || [];
	    	if($("input[name='radio-auto-renew']:checked").val() !== undefined  &&!$('#membership-renew-error-container').hasClass('hide')){
	    		$('#membership-renew-selection-error').addClass('hide');
	    	}
		    	$('input[name="isPurchaseMembershipAutoRenew"]').val('true');
		    	$('#wallet-block').addClass('hide');
		    	$('#creditcard-block-form').removeClass('display');
		    	if($('#credit-card-info-container').length == 0){
		    		$('#wallet-info-div').addClass('hide');
		    		$('#credit-card-block').removeClass('hide');
		    	}
		    	document.getElementById('credit-card-block').scrollIntoView({ behavior: 'smooth', block: 'center' });

	    },
	    
	    membershipAutoRenewOptionOptedOut: function(){
	    	window.digitalDataEvents = window.digitalDataEvents || [];
	    	if($("input[name='radio-auto-renew']:checked").val() !== undefined  &&!$('#membership-renew-error-container').hasClass('hide')){
	    		$('#membership-renew-selection-error').addClass('hide');
	    	}
	    		$('input[name="isPurchaseMembershipAutoRenew"]').val('false');
	    		if(!$('#wallet-info-div').length>0){
	    			$('#wallet-block').removeClass('hide');
	    		}
	    		$('#CheckoutPaymentForm').validate().resetForm();
	    		$('#account').removeClass('error-credit-card');
	    		$('#cc_cvc').removeClass('error-credit-card');
	    		$('#account_validator_err_msg').html('');
	    		$('#cc_cvc_err_msg').html('');
	    		$('#cc_membership_renew_error').removeClass('critical-notification');
	    		$('#cc_membership_renew_error').addClass('alert-notification');
	    	
	    },
	    
	    pageRefreshForToken: function(){
	    	window.digitalDataEvents = window.digitalDataEvents || [];
	    	digitalDataEvents.push( {nav:"Checkout Flow | refresh your page" } );
	    },

		toggleCartAccordionMobile: function(orderItemId){
			if($('#cart-accordion-header-2-'+orderItemId).hasClass('collapsed')){
				$('#cart-accordion-header-2-'+orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
				$('#cart-accordion-right-div-2-'+orderItemId).hide();
				$('#arrow-m-'+orderItemId).remove();
				$('#cart-accordion-header-2-'+orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-m-"+orderItemId+"'></i>");
			} else {
				$('#cart-accordion-header-2-'+orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
				$('#cart-accordion-right-div-2-'+orderItemId).show();
				$('#arrow-m-'+orderItemId).remove();
				$('#cart-accordion-header-2-'+orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-m-"+orderItemId+"'></i>");
			}
		},

		/**
		* Helper function to recompile & reload all checkout sections. Performed by ajax-modular
		* call to '/order-prepare' without additional request parameters.
		* @return {object} Deferred
		*/
		ajaxRefreshAllCheckoutSections: function(){
			let deferred = $.Deferred();
			COSTCO.CreditCard.initComplete = false;
			COSTCO.AjaxModular.ajax_update_state({
				url: '/order-prepare',
				always: function(data, textStatus, jqXHR, options){
					deferred.resolve();
				},
			});
			return deferred.promise();
		},

		addScreenReaderAnnouncement: function(adaMessage){
			let adaMessageDiv = $('#screen-reader-announcement');
			if(adaMessageDiv.length > 0){
				setTimeout(function(){
					adaMessageDiv.html(adaMessage);
				}, 1000);
			}
		},
		displayAllPayments: function(){
			return costcoStoreFeatures.DISPLAY_ALL_PAYMENTS;
		},
		usedPayment: function(){
			return $('input[id=usedPayMethod]').length > 0 ? $('input[id=usedPayMethod]').val() :"";
		},
		resetCheckoutPaymentFields: function(payType) {
			$('#account').val("");
			$('#cc_cvc').val("");
			$('#cc_expiry_date').val("");
			$('#cc_nameoncard').val("");
			TokenGateway.focusField = "card.number";
			$('#cc_cvc_err_msg').addClass('hide');
			$.cookie('tkSession', 'false', { path: '/' });
			createTokenSessionId().then(function(){
				Checkout.showPaymentEditSection(payType);
			});
		}
	};

	if(typeof window.COSTCO === 'undefined'){
		window.COSTCO = new Object();
	}
	window.COSTCO.Checkout = Checkout;
	return Checkout;
});



// WEBPACK FOOTER //
// ./js/checkout/checkout_helper.js